/*
 * SAM4S programming hub (Sprint 8, 2026-09-23).
 *
 * Filtering and analytics only. Every task, manual reference and limitation is
 * rendered server-side from sam4sdirect_programming_task records, so the page
 * answers with JavaScript disabled and this file just makes 80 rows usable.
 *
 * ON LEADS: browsing is not a lead. Only an action that actually asks us for
 * work or for a register is marked lead: true - the intake, the support/
 * programming products, and the new-register link. Choosing a family, choosing
 * a task, opening a manual and opening the Assistant are not.
 *
 * ON PRIVACY: the search box is for finding a task. What somebody types is
 * never sent - only whether a term was present. Nothing a visitor enters
 * anywhere on this page reaches analytics.
 */
(function () {
  function emit(event, payload) {
    var data = Object.assign({}, payload || {}, { event: event, page: window.location.pathname });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      try { window.Shopify.analytics.publish(event, data); } catch (e) { /* analytics must never break the page */ }
    }
    if (window.S4SGA4Forward) window.S4SGA4Forward(event, data);
  }

  function init(root) {
    if (root.dataset.s4pgReady) return;
    root.dataset.s4pgReady = '1';

    var items = [].slice.call(root.querySelectorAll('[data-s4pg-item]'));
    var groups = [].slice.call(root.querySelectorAll('[data-s4pg-group]'));
    var famButtons = [].slice.call(root.querySelectorAll('[data-s4pg-family]'));
    var search = root.querySelector('[data-s4pg-search]');
    var count = root.querySelector('[data-s4pg-count]');
    var empty = root.querySelector('[data-s4pg-empty]');
    var family = '';
    var term = '';

    function apply() {
      var shown = 0;
      items.forEach(function (li) {
        var okFamily = !family || li.dataset.family === family;
        var okTerm = !term || (li.dataset.haystack || '').indexOf(term) > -1;
        var visible = okFamily && okTerm;
        li.hidden = !visible;
        if (visible) shown++;
      });
      // A family heading with nothing under it is noise, so it goes too.
      groups.forEach(function (g) {
        var any = [].slice.call(g.querySelectorAll('[data-s4pg-item]')).some(function (li) { return !li.hidden; });
        g.hidden = !any;
      });
      if (count) {
        count.textContent = shown === items.length
          ? shown + ' documented tasks'
          : shown + ' of ' + items.length + ' documented tasks';
      }
      if (empty) empty.hidden = shown !== 0;
    }

    famButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        family = btn.dataset.s4pgFamily || '';
        famButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        apply();
        emit('programming_family_selected', { family: family || 'all', lead: false });
      });
    });

    if (search) {
      var timer = null;
      search.addEventListener('input', function () {
        term = search.value.trim().toLowerCase();
        apply();
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          emit('programming_search_used', { has_term: term.length > 0, lead: false });
        }, 700);
      });
    }

    root.addEventListener('toggle', function (event) {
      var d = event.target;
      if (!d || !d.hasAttribute || !d.hasAttribute('data-s4pg-details') || !d.open) return;
      var li = d.closest('[data-s4pg-item]');
      emit('programming_task_selected', {
        family: li ? li.dataset.family : null,
        task: li ? li.dataset.task : null,
        lead: false,
      });
    }, true);

    apply();
  }

  /*
   * Link events are delegated from the document, because the intake, support,
   * product and Assistant links live in the answers section above the browser
   * as well as inside it, and all of them have to be measurable.
   */
  function currentFamily() {
    var active = document.querySelector('[data-s4pg] [data-s4pg-family].is-active');
    return (active && active.dataset.s4pgFamily) || 'all';
  }

  function bindLinkEvents() {
    if (document.documentElement.dataset.s4pgLinksReady) return;
    document.documentElement.dataset.s4pgLinksReady = '1';
    document.addEventListener('click', function (event) {
      var target = event.target.closest ? event.target.closest('[data-s4pg-event]') : null;
      if (!target) return;
      emit(target.dataset.s4pgEvent, {
        document_title: target.dataset.doc || null,
        family: currentFamily(),
        lead: target.dataset.lead === 'true',
      });
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-s4pg]')).forEach(init);
    bindLinkEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
